import type { RouteRecordStringComponent } from '@vben/types'

import { requestClient } from '#/api/request'

import { defineApi } from '../../define-api'

export const menuApi = defineApi('menu', ({ prefix }) => {
  async function getMenus() {
    return requestClient.get<RouteRecordStringComponent[]>(prefix('all'))
  }

  return {
    getMenus,
  }
})
